import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import { Form, Input, Button, Col, Row, Modal, Table, Tag, Select, Radio, Popover, Spin, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LodestarIntegrationNotice from '../../../Management/estimatedclosingfee/components/LodestarIntegrationNotice'
import UpgradeToBusinessModal from '../../../Management/UpgradeToBusinessModal'
export default function Achievement() {
    const { open, step, Lenders, isFinished, showAchievement } = useSelector(state => {


        return state.manager
    })
    const dispatch = useDispatch()
    const history = useHistory()
    const [isAllApiCompleted, setIsAllApiCompleted] = useState(false)
    const [LoanOfficersList, setLoanOfficersList] = useState([])
    const [CompanyInfo, setCompanyInfo] = useState(false)
    const [EmailInfo, setEmailInfo] = useState(false)
    const [WebsiteInfo, setWebsiteInfo] = useState(false)
    const [LendersList, setLenders] = useState(0)
    const [loading, setLoading] = useState(false)
    const [isLodestarNoticeOpen, setIsLodestarNoticeOpen] = useState(false)
    const [closingfeeConfig, setClosingfeeConfig] = useState(null)
    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)
    
    const subscription = useSelector(state => {
        return state.subscriptionReducer.currentInfo
    })
    
    // 检查用户是否可以添加团队成员
    const canAddTeamMembers = () => {
        return subscription?.plan === 'enterprise' || subscription?.plan === 'business'
    }


    const lenderSvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path d="M25.2998 3.96683C25.2998 3.96683 26.7249 3.01833 27.6118 3.06858C28.4985 3.11882 29.5471 4.30072 30.7569 3.73565C31.9667 3.1704 32.0473 3.11927 32.585 3.58162C33.1226 4.04407 32.9346 4.96887 32.9346 4.96887L31.2142 7.40964L28.9563 7.66665L25.7574 5.84235L25.3002 3.96665C25.3002 3.96683 25.2998 3.96683 25.2998 3.96683Z" fill="#EDB937"/>
            <path d="M26.9698 9.66551C26.9628 9.99745 26.9214 10.3294 26.8279 10.6337C26.5725 11.4661 13.6277 22.4123 23.8724 27.8244C31.7937 32.0086 45.6247 25.6509 37.2793 16.0019L32.8723 10.9065C32.8723 10.9065 32.7679 10.3691 32.7122 9.66542C32.7079 9.49175 32.678 8.70325 32.6847 8.52783C32.7284 8.229 32.6174 7.85619 32.9618 7.10118C33.3062 6.34589 35.3613 4.75747 35.3613 4.75747C35.3613 4.75747 34.0213 3.19506 33.4556 3.36449C32.8899 3.53401 31.1029 6.79525 31.1029 6.79525C31.1029 6.79525 30.6438 6.15082 30.9414 5.16541C31.2392 4.17982 32.0733 2.68548 32.0733 2.68548C32.0733 2.68548 30.4359 2.10746 30.0485 2.54907C29.6611 2.99113 28.9167 1.97179 28.4699 2.41385C28.0233 2.85537 27.368 3.53466 27.368 3.53466C27.368 3.53466 28.4699 4.38402 28.7675 5.13157C29.0653 5.87911 28.6784 6.42272 28.6784 6.42272C28.6784 6.42272 28.7083 6.42272 28.0529 5.8792C27.3975 5.33567 26.8022 3.09342 26.0284 3.22937C25.2541 3.36458 23.4075 3.97663 24.743 4.79104L26.6192 7.37336C26.6192 7.37336 26.8079 8.1969 26.885 8.52801C26.9112 8.6944 26.9536 9.48289 26.9695 9.6656L26.9698 9.66551Z" fill="#FAD24D"/>
            <path d="M39.7704 21.8662C37.8585 28.7861 27.8199 29.2811 22.1802 27.1805C22.6044 27.5013 23.0861 27.8097 23.6383 28.1011C29.932 31.4216 39.9198 28.1535 39.7704 21.8662Z" fill="#EDB937"/>
            <path d="M29.5368 24.5611C32.5159 24.5611 34.931 22.1461 34.931 19.1669C34.931 16.1878 32.5159 13.7727 29.5368 13.7727C26.5576 13.7727 24.1426 16.1878 24.1426 19.1669C24.1426 22.1461 26.5576 24.5611 29.5368 24.5611Z" fill="#EDB937"/>
            <path d="M31.3691 17.0685C31.3691 17.0685 30.9418 16.4812 30.0936 16.3552V15.5845H29.1933V16.4003C29.1313 16.4147 29.0683 16.4309 29.0039 16.4504C27.4319 16.9235 27.7754 18.1368 27.7905 18.3274C27.806 18.518 28.1417 19.0217 28.8589 19.3728C29.5761 19.7239 30.4002 20.0062 30.4613 20.3493C30.5223 20.6926 30.2246 21.1809 29.599 21.1201C28.9734 21.0591 28.2103 20.4792 28.2103 20.4792L27.5923 21.2119C27.5923 21.2119 28.0804 21.8365 29.1933 21.9752V22.7496H30.0936V21.9697C31.2452 21.7888 31.419 20.9143 31.419 20.9143C31.419 20.9143 31.7317 19.9299 30.9536 19.3652C30.1753 18.8006 29.0154 18.6477 28.8247 18.0833C28.6341 17.5187 29.2599 17.038 29.8168 17.221C30.3738 17.4041 30.8317 17.801 30.8317 17.801L31.3696 17.0685H31.3691Z" fill="#FCFCFC"/>
            <path d="M21.3262 13.3345C21.5622 10.279 24.2486 10.1849 25.5303 9.67951C25.69 9.61659 25.8418 9.5664 25.9809 9.52782C26.0313 9.02564 26.4766 8.63257 27.0187 8.63257C27.2508 8.63257 27.4654 8.70497 27.6387 8.82664L32.5843 8.7006C32.9546 8.83807 32.7838 9.31498 32.6014 9.39249L28.0541 9.50858C28.0585 9.54586 28.061 9.58387 28.061 9.62244C28.061 9.71585 28.0471 9.80629 28.022 9.89152L32.6602 9.77301C33.0303 9.9103 32.8596 10.3877 32.677 10.4651L27.1296 10.6065C27.0931 10.6101 27.056 10.612 27.0186 10.612L26.9657 10.6108L26.9606 10.6106L26.8918 10.6125L26.8811 10.6035C26.8169 10.5954 26.7546 10.582 26.6948 10.5635C26.3939 10.997 25.9115 11.2964 25.395 11.617C24.3955 12.2375 22.5126 12.5756 22.609 14.6396L22.1246 14.6606C22.0148 12.3128 24.0267 11.8952 25.1388 11.2045C25.591 10.9236 26.0133 10.6615 26.2698 10.3112C26.1813 10.2244 26.1091 10.1222 26.0586 10.0091C25.95 10.0413 25.8316 10.0812 25.7065 10.1309C24.5417 10.5905 22.0269 10.5661 21.8101 13.3696L21.3257 13.3338L21.3262 13.3345Z" fill="#FCFCFC"/>
            <path d="M10.4662 29.7073L19.05 36.7637L17.018 38.6366L8.95361 31.0861L10.4662 29.7073Z" fill="#FCFCFC"/>
            <path d="M25.1526 24.7694C27.5918 25.4953 32.0903 26.2546 32.0903 26.2546C32.0903 26.2546 31.8362 27.913 30.4746 28.2323C29.1129 28.5519 25.4702 27.8185 25.4702 27.8185C25.4702 27.8185 24.8061 28.4881 25.9776 28.7115C27.149 28.9349 32.8838 28.8078 32.8838 28.8078C32.8838 28.8078 38.7712 25.9467 39.7847 25.5636C40.7985 25.1806 41.3999 26.1376 41.3999 26.1376C41.3999 26.1376 34.6251 31.6394 33.9914 32.1184C33.3576 32.597 22.8148 33.5286 22.8148 33.5286L19.6909 33.8541L18.4557 35.209L17.9013 36.0334L12.2666 31.2827L16.7615 28.0088C18.5338 24.96 22.713 24.0429 25.1522 24.7691L25.1526 24.7694Z" fill="#FED298"/>
            <path d="M40.6333 26.9176C38.766 28.4334 34.658 31.7648 34.1721 32.132C33.5409 32.6089 23.0402 33.5372 23.0402 33.5372L19.9287 33.8616L18.6985 35.2117L18.1464 36.0333L17.6333 35.6004C18.9184 34.3166 19.8501 33.4833 19.6219 33.6146C19.3934 33.7459 32.9338 32.4315 33.9709 31.8803C35.0081 31.329 39.94 27.2508 40.1565 26.973C40.3731 26.6952 40.6332 26.9174 40.6332 26.9174L40.6333 26.9176Z" fill="#F0BA7D"/>
            <path d="M4.6001 34.4253L8.59491 30.6667L18.4001 39.1007L15.0923 43.7001C10.7508 41.6873 7.1024 38.4462 4.6001 34.4253Z" fill="#1630AC"/>
        </svg>
    }

    const teamMemberSvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path d="M11.1783 23.7332C13.6088 23.7332 15.5792 21.7629 15.5792 19.3323C15.5792 16.9018 13.6088 14.9314 11.1783 14.9314C8.7477 14.9314 6.77734 16.9018 6.77734 19.3323C6.77734 21.7629 8.7477 23.7332 11.1783 23.7332Z" fill="#C3CCEA"/>
            <path d="M1.64307 34.0021C1.64307 28.7358 5.74792 24.4668 10.8116 24.4668C15.8753 24.4668 19.9802 28.7358 19.9802 34.0021H1.64307Z" fill="#8895BC"/>
            <path d="M35.2058 23.8079C37.6187 23.8079 39.5747 21.8519 39.5747 19.439C39.5747 17.0261 37.6187 15.0701 35.2058 15.0701C32.7929 15.0701 30.8369 17.0261 30.8369 19.439C30.8369 21.8519 32.7929 23.8079 35.2058 23.8079Z" fill="#C3CCEA"/>
            <path d="M25.7397 34.0021C25.7397 28.7741 29.8147 24.5361 34.8416 24.5361C39.8685 24.5361 43.9435 28.7741 43.9435 34.0021H25.7397Z" fill="#8895BC"/>
            <path d="M22.9911 21.8663C25.8636 21.8663 28.1922 19.5377 28.1922 16.6652C28.1922 13.7927 25.8636 11.4641 22.9911 11.4641C20.1186 11.4641 17.79 13.7927 17.79 16.6652C17.79 19.5377 20.1186 21.8663 22.9911 21.8663Z" fill="#C3CCEA"/>
            <path d="M11.7222 34.0022C11.7222 27.7784 16.5734 22.7332 22.5577 22.7332C28.5421 22.7332 33.3933 27.7784 33.3933 34.0022H11.7222Z" fill="#C3CCEA"/>
        </svg>
    }
    const companySvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path opacity="0.5" d="M19.6121 36.4836H26.4057C32.8106 36.4836 36.0131 36.4836 38.0029 34.4937C39.9927 32.5041 39.9927 29.3014 39.9927 22.8965C39.9927 22.146 39.9899 20.1655 39.9866 19.4998H6.02547C6.02226 20.1655 6.02506 22.146 6.02506 22.8965C6.02506 29.3014 6.02506 32.5041 8.01483 34.4937C10.0046 36.4836 13.2071 36.4836 19.6121 36.4836Z" fill="#C3CCEA"/>
            <path d="M11.5449 25.4442C11.5449 24.7407 12.1152 24.1704 12.8187 24.1704H16.2155C16.919 24.1704 17.4893 24.7407 17.4893 25.4442C17.4893 26.1477 16.919 26.718 16.2155 26.718H12.8187C12.1152 26.718 11.5449 26.1477 11.5449 25.4442Z" fill="#8895BC"/>
            <path d="M11.5449 30.5394C11.5449 29.8359 12.1152 29.2656 12.8187 29.2656H19.6122C20.3157 29.2656 20.886 29.8359 20.886 30.5394C20.886 31.2429 20.3157 31.8132 19.6122 31.8132H12.8187C12.1152 31.8132 11.5449 31.2429 11.5449 30.5394Z" fill="#8895BC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.8362 23.3948C31.2879 23.3211 30.614 23.3213 29.8788 23.3213H29.727C28.9917 23.3213 28.3178 23.3211 27.7696 23.3948C27.1658 23.476 26.5277 23.6669 26.0029 24.1919C25.478 24.7167 25.2871 25.3548 25.2059 25.9585C25.1322 26.5068 25.1322 27.1807 25.1323 27.9159V27.9918V28.0679C25.1322 28.803 25.1322 29.4769 25.2059 30.0251C25.2871 30.6289 25.478 31.267 26.0029 31.7918C26.5277 32.3168 27.1658 32.5077 27.7696 32.5888C28.3178 32.6625 28.9917 32.6626 29.727 32.6624H29.8029H29.8788C30.614 32.6626 31.2879 32.6625 31.8362 32.5888C32.44 32.5077 33.078 32.3168 33.6028 31.7918C34.1278 31.267 34.3187 30.6289 34.3999 30.0251C34.4736 29.4769 34.4736 28.803 34.4734 28.0678V27.9159C34.4736 27.1807 34.4736 26.5068 34.3999 25.9585C34.3187 25.3548 34.1278 24.7167 33.6028 24.1919C33.078 23.6669 32.44 23.476 31.8362 23.3948ZM27.8085 25.991L27.8044 25.9932L27.802 25.9974C27.8003 26.0007 27.7974 26.0063 27.794 26.0149C27.7788 26.0519 27.7528 26.134 27.7307 26.298C27.6826 26.6559 27.6799 27.1552 27.6799 27.9918C27.6799 28.8285 27.6826 29.3278 27.7307 29.6856C27.7528 29.8497 27.7788 29.9319 27.794 29.9687C27.7961 29.974 27.7979 29.9781 27.7995 29.9813L27.802 29.9862L27.8042 29.9905L27.8085 29.9927C27.8117 29.9946 27.8173 29.9973 27.826 30.0007C27.8628 30.016 27.945 30.042 28.1091 30.064C28.4669 30.1121 28.9663 30.1148 29.8029 30.1148C30.6395 30.1148 31.1388 30.1121 31.4967 30.064C31.6607 30.042 31.7429 30.016 31.7798 30.0007C31.7885 29.9973 31.7941 29.9946 31.7973 29.9927L31.8015 29.9905L31.8037 29.9862C31.8054 29.983 31.8083 29.9774 31.8117 29.9687C31.827 29.9319 31.853 29.8497 31.8751 29.6856C31.9231 29.3278 31.9259 28.8285 31.9259 27.9918C31.9259 27.1552 31.9231 26.6559 31.8751 26.298C31.853 26.134 31.827 26.0519 31.8117 26.0149C31.8083 26.0063 31.8054 26.0007 31.8037 25.9974L31.8015 25.9932L31.7973 25.991C31.7941 25.9893 31.7885 25.9864 31.7798 25.983C31.7429 25.9677 31.6607 25.9417 31.4967 25.9196C31.1388 25.8716 30.6395 25.8689 29.8029 25.8689C28.9663 25.8689 28.4669 25.8716 28.1091 25.9196C27.945 25.9417 27.8628 25.9677 27.826 25.983C27.8173 25.9864 27.8117 25.9893 27.8085 25.991Z" fill="#8895BC"/>
            <path d="M19.6037 9.30957H26.4148C32.8362 9.30957 36.047 9.30957 38.0419 11.2046C39.4782 12.569 39.8804 14.5322 39.993 17.8015V19.4999H6.02539V17.8015C6.13799 14.5322 6.54017 12.569 7.97651 11.2046C9.97141 9.30957 13.1822 9.30957 19.6037 9.30957Z" fill="#8895BC"/>
        </svg>
    } 
    const emailSvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path d="M26.2036 4.6001H5.23008C4.46381 4.6001 3.8335 5.22728 3.8335 6.01753V18.1723C3.8335 18.95 4.45145 19.5897 5.23008 19.5897H8.10976V23.7668L13.6961 19.5897H26.2036C26.9698 19.5897 27.6002 18.9626 27.6002 18.1723V6.01753C27.5878 5.23982 26.9698 4.6001 26.2036 4.6001Z" fill="#C3CCEA"/>
            <path d="M19.7965 22.2334H40.77C41.5362 22.2334 42.1666 22.8606 42.1666 23.6508V35.8056C42.1666 36.5833 41.5486 37.223 40.77 37.223H37.8903V41.4001L32.304 37.223H19.7965C19.0302 37.223 18.3999 36.5959 18.3999 35.8056V23.6508C18.4123 22.8606 19.0302 22.2334 19.7965 22.2334Z" fill="#8895BC"/>
            <path d="M24.0812 31.3637C25.0628 31.3637 25.8586 30.568 25.8586 29.5863C25.8586 28.6046 25.0628 27.8088 24.0812 27.8088C23.0995 27.8088 22.3037 28.6046 22.3037 29.5863C22.3037 30.568 23.0995 31.3637 24.0812 31.3637Z" fill="#FCFCFC"/>
            <path d="M30.2091 31.3637C31.1908 31.3637 31.9866 30.568 31.9866 29.5863C31.9866 28.6046 31.1908 27.8088 30.2091 27.8088C29.2274 27.8088 28.4316 28.6046 28.4316 29.5863C28.4316 30.568 29.2274 31.3637 30.2091 31.3637Z" fill="#FCFCFC"/>
            <path d="M36.3492 31.3637C37.3309 31.3637 38.1267 30.568 38.1267 29.5863C38.1267 28.6046 37.3309 27.8088 36.3492 27.8088C35.3676 27.8088 34.5718 28.6046 34.5718 29.5863C34.5718 30.568 35.3676 31.3637 36.3492 31.3637Z" fill="#FCFCFC"/>
            <path d="M9.6505 13.1294C10.6322 13.1294 11.428 12.3336 11.428 11.3519C11.428 10.3703 10.6322 9.57446 9.6505 9.57446C8.66884 9.57446 7.87305 10.3703 7.87305 11.3519C7.87305 12.3336 8.66884 13.1294 9.6505 13.1294Z" fill="#FCFCFC"/>
            <path d="M15.7906 13.1294C16.7723 13.1294 17.5681 12.3336 17.5681 11.3519C17.5681 10.3703 16.7723 9.57446 15.7906 9.57446C14.809 9.57446 14.0132 10.3703 14.0132 11.3519C14.0132 12.3336 14.809 13.1294 15.7906 13.1294Z" fill="#FCFCFC"/>
            <path d="M21.9186 13.1294C22.9002 13.1294 23.696 12.3336 23.696 11.3519C23.696 10.3703 22.9002 9.57446 21.9186 9.57446C20.9369 9.57446 20.1411 10.3703 20.1411 11.3519C20.1411 12.3336 20.9369 13.1294 21.9186 13.1294Z" fill="#FCFCFC"/>
        </svg>
    }
    const websiteSvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
            <path d="M39.0303 7.66675H6.96975C6.08443 7.66675 5.3667 8.37695 5.3667 9.25297V36.7472C5.3667 37.6233 6.08443 38.3334 6.96975 38.3334H39.0303C39.9156 38.3334 40.6334 37.6234 40.6334 36.7472V9.25297C40.6333 8.37695 39.9156 7.66675 39.0303 7.66675Z" fill="#DFE4F3"/>
            <path d="M39.0303 7.66675H23V38.3334H39.0303C39.9156 38.3334 40.6333 37.6234 40.6333 36.7472V9.25297C40.6333 8.37695 39.9156 7.66675 39.0303 7.66675Z" fill="#C3CCEA"/>
            <path d="M39.0303 7.66675H6.96975C6.08443 7.66675 5.3667 8.35327 5.3667 9.20009V15.3334C5.3667 16.1803 6.08443 16.8667 6.96975 16.8667H39.0303C39.9156 16.8667 40.6334 16.1804 40.6334 15.3334V9.20009C40.6333 8.35327 39.9156 7.66675 39.0303 7.66675Z" fill="#8895BC"/>
            <path d="M39.1002 9.19995H32.2002V15.3333H39.1002V9.19995Z" fill="#FCFCFC"/>
            <path d="M38.972 16.8667H32.3276C31.4102 16.8667 30.6665 16.1804 30.6665 15.3337V9.19978C30.6665 8.35327 31.4102 7.66675 32.3276 7.66675H38.972C39.8894 7.66675 40.6332 8.35327 40.6332 9.19978V15.3337C40.6332 16.1804 39.8894 16.8667 38.972 16.8667ZM33.9887 13.8007H37.3109V10.7328H33.9887V13.8007Z" fill="#8895BC"/>
        </svg>
    }

    const completedSvg = () => {
        return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#2E605A"/>
            <rect x="4" y="9.5354" width="2" height="7" transform="rotate(-45 4 9.5354)" fill="#E1F2E2"/>
            <rect x="14.6064" y="6" width="2" height="10" transform="rotate(45 14.6064 6)" fill="#E1F2E2"/>
        </svg>
    }
    
    const InitList = [
        {
            title: 'Add lenders',
            img: LendersList > 0 ? 'moneyBag' : "finishMoneyBag",
            svg: lenderSvg
        },
        {
            title: "Add team members",
            img: LoanOfficersList > 1 ? 'finishThreePeople' : "threePeople",
            svg: teamMemberSvg
        },
        {
            title: "Add company information",
            img: CompanyInfo ? 'finishIdCard' : "idCard",
            svg: companySvg
        },
        {
            title: "Setup email communication",
            img: EmailInfo ? 'finishMessage' : "message",
            svg: emailSvg,
            btnText: "Setup"
        },
        {
            title: "Integrate Zeitro widgets in your website",
            img: WebsiteInfo ? 'finishTable' : "table",
            svg: websiteSvg,
            btnText: "View"
        },
        // {
        //     title: "Setup estimated closing costs",
        //     key: "lodestar",
        //     img: "systemFeatures/features-0",
        // }
    ]

    useEffect(() => {
        getloanestimatedclosingfee()
    }, [])

    const getLender = async (token) => {
        const response = await fetch("/data/getcustomerlenders", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        })
        const data = await response.json()
        setLenders(data.Lenders == null ? 0 : data.Lenders.filter(item => !item.Hidden && item.Active).length)
    }

    const getCompany = async (token) => {
        const response = await fetch("/los/getcompanyprofilesetup", {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        })
        const data = await response.json()
        const hasNonEmptyField = Object.values(data).some(value => value && value !== '')
        setCompanyInfo(hasNonEmptyField)
    }

    const getWebsite = async (token) => {
        const response = await fetch("/los/getprofilesetup", {
            cache: 'no-cache',
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        })
        const data = await response.json()
        const website = data?.LandingPageSetUp?.SetupGuideStatus?.ZeitroWidget
        const value = website == undefined ? false : website
        setWebsiteInfo(value)
        dispatch({ type: "WEB_SITE_INFO", data: value })
    }

    const getOldEmailConfig = async () => {
        try {
            const response = await fetch('/los/getEmailConfigDetails', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
                    Cache: "no-cache",
                    'Content-Type': 'application/json'
                },
            });
            
            if (!response.ok) {
                message.error(`Error: ${response.statusText}`);
                return false;
            }
            
            const res = await response.json();
            const data = res.data;
            
            if (data.Email?.Provider === "Gmail" && data.Email?.Keys?.GmailAPIKey) {
                return true;
            } else if (data.Email?.Provider === "Outlook" && data.Email?.Keys?.SecretValue) {
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error fetching old email config:', error);
            return false;
        }
    }

    const getEmail = async (token) => {

        const response = await fetch("/los/getcommunicationconfig", {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            }
        })
        const data = await response.json()
        const hasOldEmailSetup = await getOldEmailConfig();
        setEmailInfo(data.IndividualEmail?.Email ? true : (hasOldEmailSetup ? true : false))
    }

    const getLoanOfficers = async (token) => {
        const response = await fetch('/los/loanofficerlist', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token,
                Cache: 'no-cache',
                'X-Image-Free': 'true',
            },
        })
        const { LoanOfficers } = await response.json()
        setLoanOfficersList(LoanOfficers.length)
    }



    const getloanestimatedclosingfee = () => {
        let token = sessionStorage.getItem("ZeitroA")
        setLoading(true)
        fetch("/los/getloanestimatedclosingfee", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
        })
        .then((response) => {
            setLoading(false)
            if (response.status !== 200) {
                alert(
                    "Looks like there was a problem. Status Code: " + response.status
                );
                return
            }
            response.json().then((js) => {
                if (js.status !== "OK") {
                console.log("Error: " + js.Error)
                } else {
                    let data = js.configurations
                    if (data) {
                        setClosingfeeConfig(data)
                    }
                }
            })
        })
        .catch(function (err) {
            setLoading(false)
            console.log("Fetch Error :-S", err);
        })
    }

    const setEnableCount = (count) => {
        let data = {
            lodeStarConfig: {
                ...closingfeeConfig.lodeStarConfig,
                suggestEnableCount: count
            },
            closingCostsDetail: closingfeeConfig.estimatedClosingCostsDetail
        }
        let token = sessionStorage.getItem("ZeitroA");
        fetch("/los/setloanestimatedclosingfee", {
            cache: "no-cache",
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
                Cache: "no-cache",
            },
            body: JSON.stringify(data)
          }).then(response => {
            if (!response.ok) {
        setEmailInfo(data.IndividualEmail.Email ? true : false)
        // if (data['EmailProvider'] == '') {
        //     setEmailInfo(false)


        // } else {
        //     setEmailInfo(true)

        // }

            } else {
                getloanestimatedclosingfee()
            }
        }).catch(error => {

        })
    }
    const setFirstFinish = () => {

        if (LendersList == 0) {
            dispatch({ type: "FIRST_NO_FINISH", data: 0 })
            return

        }
        if (LoanOfficersList == 1) {
            dispatch({ type: "FIRST_NO_FINISH", data: 1 })
            return

        }
        if (!CompanyInfo) {
            dispatch({ type: "FIRST_NO_FINISH", data: 2 })
            return

        }
        if (!EmailInfo) {
            dispatch({ type: "FIRST_NO_FINISH", data: 3 })
            return

        }
        if (!WebsiteInfo) {
            dispatch({ type: "FIRST_NO_FINISH", data: 4 })
            return

        }
    }

     useEffect(() => {
         const fetchAllData = async () => {
             const token = sessionStorage.getItem('ZeitroA')
             try {
                 // wait for all api to complete
                 await Promise.all([
                     getCompany(token),
                     getLender(token),
                     getEmail(token),
                     getWebsite(token),
                     getLoanOfficers(token),
                 ])

                 setIsAllApiCompleted(true)
             } catch (error) {
                 console.error('API call failed:', error)
             }
         }

         fetchAllData()
     }, [])

    useEffect(() => {
        if (isAllApiCompleted) {
            dispatch({ type: "FIRST", data: LoanOfficersList > 1 && CompanyInfo && EmailInfo && WebsiteInfo && LendersList > 0 })
            dispatch({ type: "IS_FINISHED", data: LoanOfficersList > 1 || CompanyInfo || EmailInfo || WebsiteInfo || LendersList > 0 })
            setFirstFinish()
        }
    }, [isAllApiCompleted, LoanOfficersList, CompanyInfo, EmailInfo, WebsiteInfo, LendersList])

    const currentStepAchievement = [
        () => {

            return LendersList > 0 ? 'StepTwoData' : 'StepTwoData disabled'
            return 'StepTwoData'


        },
        () => {


            return LoanOfficersList > 1 ? 'StepTwoData' : 'StepTwoData disabled'


        },
        () => {

            return CompanyInfo ? 'StepTwoData' : 'StepTwoData disabled'


        },
        () => {

            return EmailInfo ? 'StepTwoData' : 'StepTwoData disabled'


        },
        () => {

            return WebsiteInfo ? 'StepTwoData' : 'StepTwoData disabled'


        },
        () => {

            return 'StepTwoData disabled'


        }
    ]
    return (
        <Spin spinning={loading}>

            <div>
                <div className='ModalTitle'>
                    Initial setup
                </div>
                <div style={{ marginTop: 15, color: "#222", fontSize: 16, fontWeight: 400 }}>
                    Configure the following settings for your team so our platform will be ready for them to use when they log in.
                </div>
                <div className='StepTwoContent'>

                    {
                        InitList.map((item, index) => {

                            return (
                                <div key={index} onClick={() => {
                                    if (item.key == "lodestar") {
                                        // dispatch({ type: "OPEN", data: false })
                                        if (closingfeeConfig.lodeStarConfig.suggestEnableCount < 4) {
                                            setIsLodestarNoticeOpen(true)
                                        } else {
                                            dispatch({ type: "OPEN", data: false })
                                            history.push('/app/management?select=estimatedclosingfee')
                                        }
                                    } else {
                                        if (index === 0) {
                                            dispatch({ type: "SHOW_ACHIEVEMENT", data: false })
                                            dispatch({ type: "STEP", data: index })
                                            dispatch({ type: "SHOW_LENDERS", data: true })
                                            return
                                        }
                                        // 检查 "Add team members" 的权限
                                        if (index === 1 && !canAddTeamMembers()) {
                                            setIsUpgradeModalOpen(true)
                                            return
                                        }
                                        dispatch({ type: "SHOW_ACHIEVEMENT", data: false })
                                        dispatch({ type: "STEP", data: index })
                                    }

                                }} className='StepTwoData'>
                                    <div className="initList-item-left">
                                        <div>
                                            {item.svg && item.svg()}
                                            {/* <img src={`/images/${item.img}.svg`}></img> */}

                                        </div>
                                        <div className="initList-item-left-title">
                                            {item.title}
                                        </div>
                                    </div>
                                    <div className="initList-item-right">
                                        {currentStepAchievement[index]() === 'StepTwoData disabled' ? <div className='initList-item-right-btn'>{item.btnText || 'Add'}</div> : completedSvg()}
                                    </div>

                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <LodestarIntegrationNotice open={isLodestarNoticeOpen} onEnable={() => setEnableCount(4)} onClose={() => {setIsLodestarNoticeOpen(false); setEnableCount(closingfeeConfig.lodeStarConfig.suggestEnableCount ? closingfeeConfig.lodeStarConfig.suggestEnableCount + 1 : 2)}} />

            {/* Upgrade to Business Modal */}
            <UpgradeToBusinessModal
                isOpen={isUpgradeModalOpen}
                onClose={() => {
                    setIsUpgradeModalOpen(false)
                }}
                onUpgrade={() => {
                    setIsUpgradeModalOpen(false)
                    // 跳转到定价页面
                    dispatch({ type: "OPEN", data: false })
                    sessionStorage.setItem('path', 'Pricing')
                    window.open('/app/management', '_self')
                }}
            />

        </Spin>

    )
}
